import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { APPLICATION_ID, authFeatureConstants, EULA_Aggrement, EULA_PROPERTY_NAME, SAVE_PROPERTY, STATUS_SUBMIT } from '../../constants/commonConstants';
import { SaveProfilePropertyRequest, SaveProfilePropertyResponse } from '../../models/hospitalProfile.model';
import SendRequest from '../../services/sendRequest.service';
import { fetchHospitalProfile } from '../../../store/actions/hospitalAction';
import { canActivate, GetFirstElement } from '../../../utils/utility';
import { useHistory } from 'react-router-dom';

const AgreementModal = (): ReactElement => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const hospDetails = useSelector(({ hospital: { hospitalProfile } }: any): any => hospitalProfile);
  const history = useHistory();

  useEffect((): void => {
    if (!canActivate(authFeatureConstants.EULA_AGREEMENT)) {
      setIsModalVisible(false);
    } else if (hospDetails && hospDetails.length > 0) {
      const EULA = GetFirstElement(hospDetails)?.properties?.find((i: any): any => i.name === EULA_PROPERTY_NAME);
      if (EULA && EULA.value === 'true') {
        setIsModalVisible(false);
      } else {
        setIsModalVisible(true);
      }
    }
  }, [hospDetails]);

  const handleOk = (action: boolean): void => {
    setIsModalVisible(false);
    saveProperty(action);
  };

  const handleCancel = (): void => {
    setIsModalVisible(true);
  };

  const saveProperty = async (action: boolean): Promise<any> => {
    const properties: any = [{
      profileId: GetFirstElement(hospDetails)?.id,
      isActive: true,
      name: EULA_PROPERTY_NAME,
      value: action,
      approvalRemarks: '',
      statusName: STATUS_SUBMIT,
    }];
    const payload: SaveProfilePropertyRequest = {
      applicationId: APPLICATION_ID,
      properties,
    };
    const saveUrl = `${process.env.REACT_APP_BASE_URL}${SAVE_PROPERTY}`;
    const res: SaveProfilePropertyResponse = await SendRequest.instance.post<
      SaveProfilePropertyRequest,
      SaveProfilePropertyResponse
    >(saveUrl, payload);
    if (res && res.isSuccess) {
      if (!action) {
        history.replace('/logout');
      }
      dispatch(fetchHospitalProfile());
    }
  };

  return (
    <Modal
      visible={isModalVisible}
      onCancel={handleCancel}
      maskClosable={false}
      closable={false}
      width={800}
      style={{ top: '10px', marginBottom: '10px' }}
      footer={[
        // <Button key="disagree" className="agreement-error-btn" data-testid="disagree"
        //   onClick={(): any => handleOk(false)}>
        //   I DISAGREE
        // </Button>,
        <div className="text-center" key="agree">
          <p>By accepting, you agree to our updated terms and policies.</p>
          <Button type="primary" data-testid="agree"
            onClick={(): any => handleOk(true)}>
            Accept
          </Button>
        </div>,
      ]}
    >
      <iframe title="EULA"
        width={'100%'}
        style={{ height: '72vh', border: 'none' }}
        src={EULA_Aggrement} />
    </Modal>
  );
};

export default AgreementModal;
